module.exports = __webpack_public_path__ + "img/lightning-fill.37c357a0.svg";